import './ChatBox.css'
import { GenerateBotResponse, Chat } from './script';
import React, { useState, useEffect, useRef } from "react"
import { ReactComponent as StopIcon } from "./Source/Images/stop_circle.svg";
import { ReactComponent as ModeCommentIcon } from "./Source/Images/mode_comment.svg"
import { ReactComponent as ArrowDownIcon } from "./Source/Images/keyboard_arrow_down.svg";
import { ReactComponent as CloseIcon } from "./Source/Images/close.svg"
import { ReactComponent as ArrowUpIcon } from "./Source/Images/arrow_upward_alt.svg";

const ChatBox = () => {
    const formData = new FormData();
    const [chatHistory, setChatHistory] = useState(() => [{ id: "Bot-initial-Message" }]);
    const [showChatbox, setShowChatbox] = useState(false);
    const [message, setMessage] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);
    const scrollRef = useRef(null);
    const controllerRef = useRef(null);

    useEffect(() => {
        if (showChatbox) {
            document.body.classList.toggle("show-chatbot")
        } else {
            document.body.classList.remove("show-chatbot")
        }
    }, [showChatbox])
    
    function handleMessage() {
        if (!message) return;
        const userMessage = message;
        
        setMessage("");
        const userMessageId = Date.now().toString();
        setChatHistory(prev => [
            ...prev,
            {
                id: userMessageId,
                role: "user",
                parts: [
                    { text: userMessage }
                ],
            },
        ]);

        handleChatHistory( userMessage, chatHistory, setChatHistory);
    }
    
    async function handleChatHistory(userMessage, chatHistory, setChatHistory){
        const botMessageId = Date.now().toString() + "-thinking";
        setChatHistory(prev => [
            ...prev,
            { id: botMessageId, role: "model", parts: [{ text: "" }], thinking: true },
        ]);
        setIsGenerating(true)

        try {

            const botText = await handleResponseMessage(userMessage);

            if (!botText) {
                // console.log(botText);
                setChatHistory(prev => prev.filter(item => item.id !== botMessageId));
                setIsGenerating(false);
                return;
            }

            setChatHistory(prev =>
                prev.map(item =>
                    item.id === botMessageId
                        ? { ...item, parts: [{ text: botText }], thinking: false }
                        : item
                )
            );
        } catch (err) {
            setChatHistory(prev =>
                prev.map(item =>
                    item.id === botMessageId
                        ? { ...item, parts: [{ text: `${err.message}` }], thinking: false }
                        : item
                )
            );
        } finally {
            setIsGenerating(false);

        }
    }

    function handleResponseMessage(userMessage) {
        controllerRef.current?.abort();
        controllerRef.current = new AbortController();
        const controller = controllerRef.current;
        const signal = controller.signal;
        formData.append('message', String(userMessage));
        const botText = GenerateBotResponse({ signal, formData, controller });
        return botText;
    }

    function HandleStopThinking() {
        try {
            controllerRef.current?.abort(new DOMException('user', 'AbortError'));
        } catch {

            if (controllerRef.current)
                controllerRef.current._abortedBy = 'user';
            controllerRef.current?.abort();
        }
    }

    function pressEnter(e) {
        if (e.isComposing) return;
        if (isGenerating) return;
        if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey && !e.metaKey) {
            if (isGenerating)
                return;
            e.preventDefault();
            const trimmed = message.trim();
            if (trimmed) {
                handleMessage(message);
                setMessage("");
            }
        }
    }

    return (
        <>
            <button id="chatbot-toggler" onClick={() => setShowChatbox(!showChatbox)}>
                <span><ModeCommentIcon className="icon" /></span>
                <span><CloseIcon className="icon" /></span>
            </button>

            <div class="chatbot-popup">
                {/* <!-- Chatbot Header --> */}
                <div class="chat-header">
                    <div class="header-info">
                        <svg
                            class="chatbot-logo"
                            xmlns="http://www.w3.org/2000/svg"
                            width="50"
                            height="50"
                            viewBox="0 0 1024 1024">
                            <path
                                d="M738.3 287.6H285.7c-59 0-106.8 47.8-106.8 106.8v303.1c0 59 47.8 106.8 106.8 106.8h81.5v111.1c0 .7.8 1.1 1.4.7l166.9-110.6 41.8-.8h117.4l43.6-.4c59 0 106.8-47.8 106.8-106.8V394.5c0-59-47.8-106.9-106.8-106.9zM351.7 448.2c0-29.5 23.9-53.5 53.5-53.5s53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5-53.5-23.9-53.5-53.5zm157.9 267.1c-67.8 0-123.8-47.5-132.3-109h264.6c-8.6 61.5-64.5 109-132.3 109zm110-213.7c-29.5 0-53.5-23.9-53.5-53.5s23.9-53.5 53.5-53.5 53.5 23.9 53.5 53.5-23.9 53.5-53.5 53.5zM867.2 644.5V453.1h26.5c19.4 0 35.1 15.7 35.1 35.1v121.1c0 19.4-15.7 35.1-35.1 35.1h-26.5zM95.2 609.4V488.2c0-19.4 15.7-35.1 35.1-35.1h26.5v191.3h-26.5c-19.4 0-35.1-15.7-35.1-35.1zM561.5 149.6c0 23.4-15.6 43.3-36.9 49.7v44.9h-30v-44.9c-21.4-6.5-36.9-26.3-36.9-49.7 0-28.6 23.3-51.9 51.9-51.9s51.9 23.3 51.9 51.9z"
                            ></path>
                        </svg>
                        <h2 class="logo-text">AI Assistant</h2>
                    </div>
                    <button id="close-chatbot" onClick={() => setShowChatbox(false)}>
                        <ArrowDownIcon className="icon" />
                    </button>
                </div>

                {/* <!-- Chatbot Body --> */}
                <div class="chat-body" ref={scrollRef}>
                    <Chat chatHistory={chatHistory} containerRef={scrollRef} />
                </div>

                {/* <!-- Chatbot Footer --> */}
                <div class="chat-footer">
                    <form action="#" class="chat-form">
                        <textarea placeholder="Message..." class="message-input" required value={message}
                            onChange={(e) => { setMessage(e.target.value) }} onKeyDown={pressEnter} ></textarea>
                        <div class="chat-controls">
                            {isGenerating ? 
                                (
                                    <button type="button" id="stop-thinking" onClick={() => HandleStopThinking()} >
                                        <StopIcon className="icon" />
                                    </button>
                                )
                                : (
                                    <button type="submit" id="send-message" onClick={() => handleMessage()} disabled={isGenerating}>
                                        <ArrowUpIcon className="icon" />
                                    </button>
                                )
                            }
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ChatBox